import axios from "axios";
import { AxiosStatus } from "axios-status";
import store from "./store";

const instance = axios.create({
  baseURL: "https://ebird.org/ws2.0/",
  headers: { "X-eBirdApiToken": "ttn1ql3pt430" }
});

const axiosStatus = new AxiosStatus({});
axiosStatus.register(instance);
axiosStatus.on("busy", val => store.commit("SET_BUSY", val));

const fetchObservations = controls => {
  const params = {
    lat: controls.location.lat,
    lng: controls.location.lng,
    dist: controls.dist,
    back: controls.back,
    detail: "full"
  };
  // TODO: get a list of location ids nearby, then loop through them.
  // Same as per code currently on OFO/TOC.
  return instance.get("data/obs/geo/recent/notable", { params });
  // return instance.get("data/obs/geo/recent", { params });
};

export default {
  fetchObservations
};
